import { textSmallSemiBold } from '@hud/web-components/DesignSystem/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .header {
    display: flex;
    position: relative;
    padding: var(--space-50) 0;
    margin-bottom: var(--space-500);
  }

  .body {
    padding-right: var(--space-50);
    padding-left: var(--space-50);
    padding-bottom: var(--space-400);

    display: flex;
    flex-direction: column;
    gap: var(--space-75);
    flex: 1;
  }

  .footer {
    margin-top: auto;
    padding-top: var(--space-200);
  }

  .backToApp {
    color: var(--text-standard-primary);
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--space-75);
    text-decoration: none;
    ${textSmallSemiBold}
  }
`;
